// extracted by mini-css-extract-plugin
module.exports = {"cards":"ingredient-cards_cards__1STKv"};